import NotFound from '../components/pages/NotFound';
import { GetStaticProps } from 'next';

export default NotFound;
export const getStaticProps: GetStaticProps = async () => ({
        props: {},
    });
